import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast } from "../../../components/toast/Toasts";

export const findRMWiseReport = createAsyncThunk(
  "Leads/RMwiseReport",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Leads/RMwiseReport`,
        payload
      );
      if (response.data.Status === 200) {
        return response.data?.Data;
      } else {
        throw new Error(response?.data?.Details);
      }
    } catch (error: any) {
      console.error("Error Fetching Relationship Manager Wise Report :", error);
      ErrorToast(error.message || "something went wrong!");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
